.button {
  width: fit-content;
  color: var(--color-text-on-primary);
  background-color: var(--color-primary);
  cursor: pointer;
  font-size: 1rem;
  font-family: var(--font-family-base);
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  border: none;
}

.button.secondary {
  background-color: var(--color-muted);
  color: var(--color-text);
  padding: 0.5rem;
}

.button.cta {
  background-color: var(--color-cta);
  color: var(--color-primary);
  border: 1px solid var(--color-primary);
  font-weight: 400;
}

.button.large {
  padding: 1.75rem 3rem;
}

.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.linkButton {
  width: fit-content;
  background-color: transparent;
  color: var(--color-text);
  text-decoration: underline;
  cursor: pointer;
  padding: 0.125rem;
  border: none;
  font-family: inherit;
}

.linkButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.iconButton {
  width: fit-content;
  background-color: transparent;
  color: var(--color-text);
  cursor: pointer;
  padding: 0.75rem;
  border: none;
  font-family: inherit;
}

.iconButton.active {
  color: var(--color-primary);
}

.iconButton.muted {
  color: var(--color-text-muted);
}

.iconButton.info.active {
  color: var(--color-cta);
}

.iconButton.inline {
  position: relative;
  top: -5px;
  padding: 0;
}

.iconButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
